// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__iMP1Z","clickEffect":"styles_clickEffect__r33rC","pulse":"styles_pulse__cXVgp"};